import { IOption } from '../../../../../types/global'

export type CheckpointVisibility = 'visible' | 'hidden'

const checkpointVisibilityOptions: Array<IOption<CheckpointVisibility>> = [
  { title: 'Показать', value: 'visible' },
  { title: 'Скрыть', value: 'hidden' },
]

export default checkpointVisibilityOptions
